// Emoji unified code point converter matching entriks-hr
export function toUnified(emojiStr) {
  if (!emojiStr) return '';
  return [...emojiStr]
    .map((char) => char.codePointAt(0).toString(16))
    .filter((code) => code !== 'fe0f') // strip variation selector-16 for standard asset mapping
    .join('-');
}

export function resolveEmojiUnified(emojiStr) {
  const unified = toUnified(emojiStr);
  return unified;
}

export function getEmojiAssetUrl(emojiStr, style = 'apple') {
  const unified = resolveEmojiUnified(emojiStr);
  if (!unified) return '';
  // Apple emoji asset CDN (same as used in iOS and macOS / Entriks HR)
  return `https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/${unified}.png`;
}

export function getTwemojiSvgUrl(emojiStr) {
  const unified = resolveEmojiUnified(emojiStr);
  if (!unified) return '';
  return `https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${unified}.svg`;
}
